module.exports = __webpack_public_path__ + "img/features-3.691d177b.png";